// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
   font-weight: normal;
   margin-top: 50px;
   text-align: center;
}
.container {
   justify-content: center;
   padding: 10px;
}
.category {
   padding: 1em;
}
.category, .content {
   list-style: none;
   margin: 0;
   padding: 0;
}
.category .fa-angle-down {
   cursor: pointer;
   margin-right: 5px;
   transition: transform .4s;
}
.collapse {
   transform: rotate(-90deg);
}
.category>li {
   overflow: hidden;
}
.category .section {
   padding: 10px 0;
   width: 900px;
}
.category .line {
   background-color: rgba(0,0,0,.1);
   height: 1px;
   margin-left: 10px;
}

.content {
   overflow: hidden;
   position: relative;
}
.content .gradient {
   background: linear-gradient(transparent 50%, #f7f8f9);
   position: absolute;
   bottom: 0;
   left: 0;
   right: 0;
   height: 120px;
}
.content li {
   background-color: #fff;
   border-radius: 2px;
   box-shadow: 0 1px 3px rgba(0,0,0,0.1);
   display: inline-block;
   margin: 10px 0 50px;
   width: 180px;
}
.content li + li {
   margin-left: 20px;
}
.category>li:last-child li {
   margin-bottom: 25px;
}
.content a {
   cursor: pointer;
   display: block;
   padding: 10px;
}
.content a:hover {
   text-decoration: none;
}
.content .title {
   margin-top: 1em;
   font-weight: bold;
   text-align: center;
   overflow: hidden;
   white-space: nowrap;
   text-overflow: ellipsis;
}
.content .desc {
   font-size: 11px;
   opacity: .6;
   margin: 10px auto;
   text-align: center;
   overflow: hidden;
   white-space: nowrap;
   text-overflow: ellipsis;
}
.content img {
   display: block;
   height: 160px;
   width: 160px;
   object-fit: cover;
}
.content button {
   background-color: #2ab4c0;
   color: #fff;
   cursor: pointer;
   border: none;
   border-radius: 2em;
   display: block;
   font-size: 12px;
   margin: auto;
   outline: none;
   padding: 4px;
   transition: background-color .2s;
   text-transform: uppercase;
   width: 100px;
}
.content button:active {
   background-color: #18929d;
}
.content .status {
   color: #2ab4c0;
   font-size: 12px;
   padding: 4px;
   text-align: center;
}
.content .status i {
   margin-right: .5em;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-form/forms/forms.component.css"],"names":[],"mappings":"AAAA;GACG,mBAAmB;GACnB,gBAAgB;GAChB,kBAAkB;AACrB;AACA;GACG,uBAAuB;GACvB,aAAa;AAChB;AACA;GACG,YAAY;AACf;AACA;GACG,gBAAgB;GAChB,SAAS;GACT,UAAU;AACb;AACA;GACG,eAAe;GACf,iBAAiB;GACjB,yBAAyB;AAC5B;AACA;GACG,yBAAyB;AAC5B;AACA;GACG,gBAAgB;AACnB;AACA;GACG,eAAe;GACf,YAAY;AACf;AACA;GACG,gCAAgC;GAChC,WAAW;GACX,iBAAiB;AACpB;;AAEA;GACG,gBAAgB;GAChB,kBAAkB;AACrB;AACA;GACG,qDAAqD;GACrD,kBAAkB;GAClB,SAAS;GACT,OAAO;GACP,QAAQ;GACR,aAAa;AAChB;AACA;GACG,sBAAsB;GACtB,kBAAkB;GAClB,qCAAqC;GACrC,qBAAqB;GACrB,mBAAmB;GACnB,YAAY;AACf;AACA;GACG,iBAAiB;AACpB;AACA;GACG,mBAAmB;AACtB;AACA;GACG,eAAe;GACf,cAAc;GACd,aAAa;AAChB;AACA;GACG,qBAAqB;AACxB;AACA;GACG,eAAe;GACf,iBAAiB;GACjB,kBAAkB;GAClB,gBAAgB;GAChB,mBAAmB;GACnB,uBAAuB;AAC1B;AACA;GACG,eAAe;GACf,WAAW;GACX,iBAAiB;GACjB,kBAAkB;GAClB,gBAAgB;GAChB,mBAAmB;GACnB,uBAAuB;AAC1B;AACA;GACG,cAAc;GACd,aAAa;GACb,YAAY;GACZ,iBAAiB;AACpB;AACA;GACG,yBAAyB;GACzB,WAAW;GACX,eAAe;GACf,YAAY;GACZ,kBAAkB;GAClB,cAAc;GACd,eAAe;GACf,YAAY;GACZ,aAAa;GACb,YAAY;GACZ,gCAAgC;GAChC,yBAAyB;GACzB,YAAY;AACf;AACA;GACG,yBAAyB;AAC5B;AACA;GACG,cAAc;GACd,eAAe;GACf,YAAY;GACZ,kBAAkB;AACrB;AACA;GACG,kBAAkB;AACrB","sourcesContent":["h1 {\n   font-weight: normal;\n   margin-top: 50px;\n   text-align: center;\n}\n.container {\n   justify-content: center;\n   padding: 10px;\n}\n.category {\n   padding: 1em;\n}\n.category, .content {\n   list-style: none;\n   margin: 0;\n   padding: 0;\n}\n.category .fa-angle-down {\n   cursor: pointer;\n   margin-right: 5px;\n   transition: transform .4s;\n}\n.collapse {\n   transform: rotate(-90deg);\n}\n.category>li {\n   overflow: hidden;\n}\n.category .section {\n   padding: 10px 0;\n   width: 900px;\n}\n.category .line {\n   background-color: rgba(0,0,0,.1);\n   height: 1px;\n   margin-left: 10px;\n}\n\n.content {\n   overflow: hidden;\n   position: relative;\n}\n.content .gradient {\n   background: linear-gradient(transparent 50%, #f7f8f9);\n   position: absolute;\n   bottom: 0;\n   left: 0;\n   right: 0;\n   height: 120px;\n}\n.content li {\n   background-color: #fff;\n   border-radius: 2px;\n   box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n   display: inline-block;\n   margin: 10px 0 50px;\n   width: 180px;\n}\n.content li + li {\n   margin-left: 20px;\n}\n.category>li:last-child li {\n   margin-bottom: 25px;\n}\n.content a {\n   cursor: pointer;\n   display: block;\n   padding: 10px;\n}\n.content a:hover {\n   text-decoration: none;\n}\n.content .title {\n   margin-top: 1em;\n   font-weight: bold;\n   text-align: center;\n   overflow: hidden;\n   white-space: nowrap;\n   text-overflow: ellipsis;\n}\n.content .desc {\n   font-size: 11px;\n   opacity: .6;\n   margin: 10px auto;\n   text-align: center;\n   overflow: hidden;\n   white-space: nowrap;\n   text-overflow: ellipsis;\n}\n.content img {\n   display: block;\n   height: 160px;\n   width: 160px;\n   object-fit: cover;\n}\n.content button {\n   background-color: #2ab4c0;\n   color: #fff;\n   cursor: pointer;\n   border: none;\n   border-radius: 2em;\n   display: block;\n   font-size: 12px;\n   margin: auto;\n   outline: none;\n   padding: 4px;\n   transition: background-color .2s;\n   text-transform: uppercase;\n   width: 100px;\n}\n.content button:active {\n   background-color: #18929d;\n}\n.content .status {\n   color: #2ab4c0;\n   font-size: 12px;\n   padding: 4px;\n   text-align: center;\n}\n.content .status i {\n   margin-right: .5em;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
